import { DtoXCODescuentoMst02 } from './../dominio/dtoDescuentos';
import { AppConfig } from 'src/environments/appconfig';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UHttpsClient } from '../../../../seguridad/seguridad/uhttpsClient';

@Injectable()
export class CoAutorizacionDescuentoDetalleService {

    private url = `${this.config.getEnv('proxy')}spring/comercial/codocumento/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public obtenerAutorizacionDescuento04(autorizacion: number): Promise<DtoXCODescuentoMst02> {
        return this.http.get(`${this.url}obtenerAutorizacionDescuento04/` + autorizacion,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as DtoXCODescuentoMst02;
            })
            .catch(error => new DtoXCODescuentoMst02);
    }
}

